import axios from 'axios';

import { BASE_HOST_URL } from '../config';

let baseURL = BASE_HOST_URL;
if (process.env.NODE_ENV === 'development') {
  baseURL = 'http://localhost:3005';
}

export function getAllPresents() {
  return axios.get(`${baseURL}/api/v1/presents`);
}

export function presentsFiltered(filters) {
  let query = '';
  for (let i = 0; i < filters.length; i++) {
    if (query.length === 0) query += `${filters[i].label}=${filters[i].value}`;
    else query += `&${filters[i].label}=${filters[i].value}`;
  }
  return axios.get(`${baseURL}/api/v1/presents/filters?${query}`);
}

export function setManualInvoiceId(bookingId, invoiceId) {
  return axios.put(`${baseURL}/api/v1/presents/invoice/${bookingId}`, { invoiceId });
}



// WEBPACK FOOTER //
// ./src/services/presents.js